import React from 'react';
import { Container } from '@mui/system';
import { Box, Typography } from '@mui/material';
import { FooterContainer } from '../../components/ScreenContainer/FooterScreenContainer/FooterContainer';
import { strings } from '../../constants/strings';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';

const Shop = () => {
    const { themeStyle } = useThemeContext();

    return (
        <Container
            disableGutters
            maxWidth={false}
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-start',
                width: '100%',
                marginTop: 5,
                height: '100vh',
            }}>
            <FooterContainer>
                <Box sx={{ width: '100%', maxWidth: 600 }}>
                    <Typography
                        sx={{
                            mb: 2,
                            fontSize: {
                                sm: 24,
                                xs: 16,
                                lg: 24,
                            },
                        }}
                        style={{
                            fontFamily: FONT_ENUM.REGULAR_HEADER,
                            color: theme[themeStyle].lightWhite,
                            textAlign: 'center',
                        }}>
                        {strings.shop}
                    </Typography>
                </Box>
            </FooterContainer>
        </Container>
    );
};

export { Shop };
